export interface SavedQuery {
  id?: string;
  name?: string | null;
  userId?: string;
  creationDate?: Date;
  searchQuery?: string | null;
  filters?: string | null;
}

export class SavedQueryParamsBuilder {
  private params: SavedQuery = {};

  name(value?: string | null): SavedQueryParamsBuilder {
    this.params.name = value || null;
    return this;
  }

  searchQuery(value?: string | null): SavedQueryParamsBuilder {
    this.params.searchQuery = value || null;
    return this;
  }

  filters(value?: string | null): SavedQueryParamsBuilder {
    this.params.filters = value || null;
    return this;
  }

  build(): SavedQuery {
    return { ...this.params };
  }
}
